import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPenToSquare,
    faTrash,
    faDesktop
} from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';

const PlataformaRow = ({ plataforma, onEdit, onDelete }) => {

    const handleClickModify = () => {
        onEdit(plataforma);
    };

    const handleClickDelete = async () => {
        Swal.fire({
            title: `¿Está seguro que desea eliminar la plataforma ${plataforma.codPlataforma}?`,
            showDenyButton: true,
            confirmButtonText: 'Sí, estoy seguro',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                onDelete(plataforma);
            }
        });
    };

    const handleOpenLink = () => {
        if (plataforma.link) {
            window.open(plataforma.link, '_blank');
        }
    };

    return (
        <div className="plataformaRow">
            <div className="infoContainer">
                <FontAwesomeIcon icon={faDesktop} className="rrIcon" id="primaryIcon" />
                <div className="infoDiv">
                    <h6>Código Plataforma:</h6>
                    <label id="codPlataformaLabel">{plataforma.codPlataforma}</label>
                </div>
                <div className="infoDiv">
                    <h6>Nombre:</h6>
                    <label>{plataforma.name}</label>
                </div>
                <div className="infoDiv">
                    <h6>Link:</h6>
                    {plataforma.link ? (
                        <label className="linkLabel" onClick={handleOpenLink}>
                            {plataforma.link}
                        </label>
                    ) : (
                        <label>-</label>
                    )}
                </div>
                <div className="infoDiv">
                    <h6>Estado:</h6>
                    <label className={plataforma.enabled ? 'enabledChip' : 'disabledChip'}>
                        {plataforma.enabled ? 'Activo' : 'Inactivo'}
                    </label>
                </div>
            </div>
            <div className="funcionesDiv">
                <FontAwesomeIcon icon={faPenToSquare} onClick={handleClickModify} className="rrIcon" />
                <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={handleClickDelete} />
            </div>
        </div>
    );
};

export default PlataformaRow;
